import { hosts } from '../../config';
import { BaseClient } from '../BaseClient/BaseClient';
import {
  EnsureQuestionnaireConfigurationHandler,
  GetCandidateProfileHandler,
  GetCandidateQuestionnaireHandler,
  GetQuestionnairePreviewHandler,
  SubmitCandidateQuestionnaireHandler,
  UpdateCandidateProfileHandler,
  UpdateQuestionnaireConfigurationHandler,
} from './Questionnaire.dto';

export class CommunicationClient extends BaseClient {
  constructor() {
    super();
    this.getCandidateQuestionnaire = this.getCandidateQuestionnaire.bind(this);
  }

  getCandidateQuestionnaire: GetCandidateQuestionnaireHandler = ({ token }) => {
    return this.request(
      {
        url: `${hosts.communicationApi()}/questionnaire/${token}`,
        method: 'GET',
        params: { token },
      },
      false,
    );
  };

  submitCandidateQuestionnaire: SubmitCandidateQuestionnaireHandler = ({ token, candidateQuestionnaire }) => {
    return this.request(
      {
        url: `${hosts.communicationApi()}/questionnaire/${token}`,
        method: 'PUT',
        data: candidateQuestionnaire,
      },
      false,
    );
  };

  getCandidateProfile: GetCandidateProfileHandler = ({ token }) => {
    return this.request(
      {
        url: `${hosts.communicationApi()}/candidate/profile/${token}`,
        method: 'GET',
      },
      false,
    );
  };

  updateCandidateProfile: UpdateCandidateProfileHandler = ({ token, candidateProfile }) => {
    return this.request(
      {
        url: `${hosts.communicationApi()}/candidate/profile/${token}`,
        method: 'PUT',
        data: candidateProfile,
      },
      false,
    );
  };

  getQuestionnairePreview: GetQuestionnairePreviewHandler = ({ es_person_id, job_id, selected_language }) => {
    return this.request({
      url: `${hosts.communicationApi()}/questionnaire/preview`,
      method: 'POST',
      data: {
        es_person_id,
        job_id,
        selected_language,
      },
    });
  };

  updateQuestionnaireConfiguration: UpdateQuestionnaireConfigurationHandler = (data) => {
    return this.request({
      url: `${hosts.communicationApi()}/questionnaire/configuration`,
      method: 'PUT',
      data,
    });
  };

  ensureQuestionnaireConfiguration: EnsureQuestionnaireConfigurationHandler = (data) => {
    return this.request({
      url: `${hosts.communicationApi()}/questionnaire/configuration/ensure`,
      method: 'POST',
      data,
    });
  };
}

export const communicationClient = new CommunicationClient();
